<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" id="rabb" title="Abbreviations">
<p class="fmh"><span class="right_1" epub:type="pagebreak" id="page_xv" title="xv"><a href="#/text/9780253041401_Contents#abb"><b>ABBREVIATIONS</b></a></span></p>
<table>
<tbody><tr>
<td style="width:20%"><p class="tab">APS</p></td>
<td style="width:80%"><p class="tab">American Philosophical Society</p></td>
</tr>
<tr>
<td><p class="tab"><i>ARCIA</i></p></td>
<td><p class="tab"><i>Annual Reports</i> of the [United States] Commissioner of Indian Affairs</p></td>
</tr>
<tr>
<td><p class="tab">BL</p></td>
<td><p class="tab">Beinecke Library</p></td>
</tr>
<tr>
<td><p class="tab">BIA</p></td>
<td><p class="tab">Bureau of Indian Affairs</p></td>
</tr>
<tr>
<td><p class="tab">CCF</p></td>
<td><p class="tab">Central Classified Files</p></td>
</tr>
<tr>
<td><p class="tab">COLL</p></td>
<td><p class="tab">Collection</p></td>
</tr>
<tr>
<td><p class="tab">EW</p></td>
<td><p class="tab">Eleazer Williams</p></td>
</tr>
<tr>
<td><p class="tab">GBAR</p></td>
<td><p class="tab">Green Bay Agency Records</p></td>
</tr>
<tr>
<td><p class="tab">HC</p></td>
<td><p class="tab">Hamilton College, Clinton, New York</p></td>
</tr>
<tr>
<td><p class="tab">ICC</p></td>
<td><p class="tab">Indian Claims Commission</p></td>
</tr>
<tr>
<td><p class="tab">JAJ</p></td>
<td><p class="tab">John Archiquette Journals</p></td>
</tr>
<tr>
<td><p class="tab">JAPR</p></td>
<td><p class="tab">John Archiquette Police Reports</p></td>
</tr>
<tr>
<td><p class="tab">JFC</p></td>
<td><p class="tab">James Fenimore Cooper</p></td>
</tr>
<tr>
<td><p class="tab">JR</p></td>
<td><p class="tab"><i>Jesuit Relations and Allied Documents</i></p></td>
</tr>
<tr>
<td><p class="tab">M</p></td>
<td><p class="tab">Microcopy</p></td>
</tr>
<tr>
<td><p class="tab">MR</p></td>
<td><p class="tab">Microfilm Reel</p></td>
</tr>
<tr>
<td><p class="tab">MSS</p></td>
<td><p class="tab">Manuscript Collection</p></td>
</tr>
<tr>
<td><p class="tab">NA</p></td>
<td><p class="tab">National Archives</p></td>
</tr>
<tr>
<td><p class="tab">NYIA</p></td>
<td><p class="tab">New York Indian Agency</p></td>
</tr>
<tr>
<td><p class="tab">NYSA</p></td>
<td><p class="tab">New York State Archives</p></td>
</tr>
<tr>
<td><p class="tab">NYSL</p></td>
<td><p class="tab">New York State Library</p></td>
</tr>
<tr>
<td><p class="tab">OIA</p></td>
<td><p class="tab">Office of Indian Affairs</p></td>
</tr>
<tr>
<td><p class="tab">OLFP</p></td>
<td><p class="tab">Oneida Language and Folklore Project</p></td>
</tr>
<tr>
<td><p class="tab">ONIW</p></td>
<td><p class="tab">Oneida Nation of Indians of Wisconsin</p></td>
</tr>
<tr>
<td><p class="tab">REV</p></td>
<td><p class="tab">Reverend</p></td>
</tr>
<tr>
<td><p class="tab">RG</p></td>
<td><p class="tab">Record Group</p></td>
</tr>
<tr>
<td><p class="tab">Rt. Rev.</p></td>
<td><p class="tab">Right Reverend/Bishop</p></td>
</tr>
<tr>
<td><p class="tab">SK</p></td>
<td><p class="tab">Samuel Kirkland</p></td>
</tr>
<tr>
<td><p class="tab"><span class="right_1" epub:type="pagebreak" id="page_xvi" title="xvi">SPG</span></p></td>
<td><p class="tab">Society for the Propagation of the Gospel in Foreign Parts</p></td>
</tr>
<tr>
<td><p class="tab"><i>Stat.</i></p></td>
<td><p class="tab"><i>United States Statutes at Large</i></p></td>
</tr>
<tr>
<td><p class="tab">USGPO</p></td>
<td><p class="tab">United States Government Printing Office</p></td>
</tr>
<tr>
<td><p class="tab">UWGB</p></td>
<td><p class="tab">University of Wisconsin at Green Bay</p></td>
</tr>
<tr>
<td><p class="tab">Very Rev.</p></td>
<td><p class="tab">Very Reverend/Senior Priest</p></td>
</tr>
<tr>
<td><p class="tab"><i>WHC</i></p></td>
<td><p class="tab"><i>Wisconsin Historical Collections</i></p></td>
</tr>
<tr>
<td><p class="tab">WHS</p></td>
<td><p class="tab">Wisconsin Historical Society</p></td>
</tr>
<tr>
<td><p class="tab">WHSARC</p></td>
<td><p class="tab">Wisconsin Historical Society Area Research Center</p></td>
</tr>
<tr>
<td><p class="tab">WPA</p></td>
<td><p class="tab">Works Progress Administration</p></td>
</tr>
<tr>
<td><p class="tab">YU</p></td>
<td><p class="tab">Yale University</p></td>
</tr>
</tbody></table>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780253041401_Abbreviations.vue?b0a1de74